import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { WrapperDesktop, WrapperMobile } from './styles';
import { formatMoney } from '@spa/shared/utils';
import { MediaContext } from '@spa/shared/contexts/media';

const Pricing = ({ firstPayment, referencePrice }) => {
  const { t } = useTranslation();
  const { is } = useContext(MediaContext);

  const { amount: firstPaymentAmount, currency_code: firstPaymentCurrency } = firstPayment || {};
  const { amount: referenceAmount, currency_code: referenceCurrency } = referencePrice || {};

  const formattedFirstPaymentPrice =
    firstPaymentAmount && firstPaymentCurrency ? formatMoney(firstPaymentAmount, firstPaymentCurrency) : null;
  const formattedReferencePrice =
    referenceAmount && referenceCurrency ? formatMoney(referenceAmount, referenceCurrency) : null;

  const Wrapper = useMemo(() => (is.mobile ? WrapperMobile : WrapperDesktop), [is.mobile]);

  return (
    <Wrapper>
      {formattedFirstPaymentPrice || formattedReferencePrice}
      <span>{` /${t('month')}`}</span>
    </Wrapper>
  );
};

Pricing.propTypes = {
  firstPayment: PropTypes.object,
  referencePrice: PropTypes.object
};

export default Pricing;
